import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import Home from './pages/Home';
import Resume from './pages/Resume';
import Contact from './pages/Contact';
import Services from './pages/Services';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="resume" element={<Resume />} />
        <Route path="contact" element={<Contact />} />
        {/* Built, reachable, but intentionally absent from the nav until it has content. */}
        <Route path="services" element={<Services />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
